import AvApi from '@availity/api-axios';
import getEssentialsUrl from '../config';

class UserApi extends AvApi {
  constructor() {
    super({
      url: `${getEssentialsUrl()}/cloud/web/appl/user-management/legacy/sdk/platform/v1/users/me`,
      api: false,
      withCredentials: true,
      sessionBust: false,
    });
  }

  getUserDetails() {
    return this.query({}).then((res) => res.data);
  }
}

export default new UserApi();
